import { useState, useRef } from 'react';
import { notification } from 'antd';
import { intialPaginationState, unexpectedError } from '../../../common_functions';

const useReportHistory = (props, defaultFilters = {}) => {
  const formRef = useRef(null);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);

  const getHistory = async (paginationState, filters = {}) => {
    setLoading(true);
    const mergedFilters = { ...defaultFilters, ...filters };
    try {
      const dataFilters = {
        fields: [
          'id',
          'date_created',
          'status',
          'collections',
          'object_titles',
          'number_of_records_in_pdf',
          'report_type',
          'report.id',
          'report.filename_download',
        ],
        sort: '-id',
        filters: mergedFilters,
        offset: paginationState.pageSize * (paginationState.current - 1),
        limit: paginationState.pageSize,
        meta: 'filter_count',
      };
      const response = await props.getItems('report_history', dataFilters);
      paginationState.total = response.meta.filter_count;
      setPagination({ ...paginationState });
      setHistory(response.data);
    } catch (error) {
      console.error(error);
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = async (newPagination, filters) => {
    setPagination(newPagination);
    setLoading(true);
    const filtersitems = {};
    for (const key in filters) {
      if (filters[key]) {
        filtersitems[key] =
          key === 'number_of_records_in_pdf'
            ? { _eq: filters[key][0] }
            : { _icontains: filters[key][0] };
      }
    }
    await getHistory(newPagination, filtersitems);
  };

  const handleDownLoadFile = async (fileId, name) => {
    try {
      setLoading(true);
      await props.getPdfFile(fileId, name);
    } catch {
      notification.error({
        message: 'An error occurred while downloading the report. Please try again!',
      });
    } finally {
      setLoading(false);
    }
  };

  const resetFilters = async () => {
    formRef.current.resetFields();
    await getHistory(intialPaginationState);
  };

  return {
    formRef,
    pagination,
    loading,
    history,
    setHistory,
    getHistory,
    handleTableChange,
    handleDownLoadFile,
    resetFilters,
  };
};

export default useReportHistory;
